const translations = {
  // Navbar
  nav_home: 'Home',
  nav_contact: 'Contact Us',
  nav_get_in_touch: 'Get in Touch',

  // Hero
  hero_tag: 'Innovation',
  hero_title_line1: 'Advancing',
  hero_title_line2: 'Solutions',
  hero_contact_btn: 'Contact Us',

  // About Section (home)
  about_tag: 'Who We Are',
  about_title: 'Committed to Scientific',
  about_title_highlight: 'Excellence',
  about_title_suffix: 'and Patient Care',
  about_p1: 'Vixtra Inc. is a new pharmaceutical company focused on the development, manufacture and distribution of unique combination products for applications where there is an evident unmet need or that can significantly impact quality of care.',
  about_p2: "With existing strategic relationships as well as having access to several patented technologies and platforms, Vixtra's products will deliver unrivaled clinical performance in various therapeutic areas in human pharmaceuticals.",

  pillar_dev_title: 'Development',
  pillar_dev_desc: 'Pioneering unique combination pharmaceutical products that address unmet clinical needs.',
  pillar_mfg_title: 'Manufacture',
  pillar_mfg_desc: 'State-of-the-art manufacturing processes ensuring the highest quality standards.',
  pillar_dist_title: 'Distribution',
  pillar_dist_desc: 'Strategic distribution networks delivering products where they are needed most.',

  // Stats Section
  stat1_value: 'Patented',
  stat1_label: 'Technologies & Platforms',
  stat2_value: 'Unique',
  stat2_label: 'Combination Products',
  stat3_value: 'Multiple',
  stat3_label: 'Therapeutic Areas',
  stat4_value: 'Strategic',
  stat4_label: 'Industry Relationships',

  // Contact CTA
  cta_tag: 'Get in Touch',
  cta_title: 'How To Contact Us',
  cta_desc: 'Speak with a Vixtra representative regarding our products and services.',
  cta_btn: 'Contact Us',

  // Contact Page
  contact_page_tag: 'Reach Out',
  contact_page_title: 'Contact Us',
  contact_page_subtitle: "Have questions about our products or services? We'd love to hear from you.",
  contact_breadcrumb: 'Contact Us',
  contact_info_tag: 'Get in Touch',
  contact_info_title: "We're Here to Help",
  contact_info_desc: 'If you have any questions or would like to speak with a Vixtra Inc. representative regarding our products and services, please reach out using any of the methods below.',
  contact_email_label: 'Email Us',
  contact_phone_label: 'Call Us',
  contact_form_title: 'Send Us a Message',
  contact_first_name: 'First Name',
  contact_last_name: 'Last Name',
  contact_email: 'Email Address',
  contact_phone: 'Phone Number',
  contact_subject: 'Subject',
  contact_subject_placeholder: 'Select a subject',
  contact_subject_products: 'Products & Services',
  contact_subject_partnership: 'Partnership Inquiry',
  contact_subject_general: 'General Inquiry',
  contact_subject_other: 'Other',
  contact_message: 'Message',
  contact_message_placeholder: 'Tell us how we can help...',
  contact_submit: 'Send Message',
  contact_submitting: 'Sending...',
  contact_success_title: 'Message Sent!',
  contact_success_desc: 'Thank you for reaching out. A Vixtra representative will get back to you shortly.',

  // Footer
  footer_nav_title: 'Navigation',
  footer_contact_title: 'Contact',
  footer_copyright: '\u00a9 Vixtra 2026. All rights reserved.',

  // Cookie Consent
  cookie_message: 'We use cookies to enhance your experience on our website. By continuing to browse, you agree to our use of cookies.',
  cookie_accept: 'Accept',
  cookie_decline: 'Decline',
  cookie_policy_link: 'Cookie Policy',
};

export default translations;
